import { css } from 'styled-components';
import { fontWeight } from '../../theme/typography/fontWeight.js';
import { fontSize } from '../../theme/typography/fontSize.js';
import { themeGet } from '../../v2/foundation/theme/themeGet/get.js';

var getAppearance = function getAppearance(appearance) {
  switch (appearance) {
    case 'light':
      return themeGet('colors.gray.300');
    case 'neutral':
      return themeGet('colors.gray.700');
    case 'destructive':
      return themeGet('colors.red.500');
    case 'default':
    default:
      return themeGet('colors.gray.800');
  }
};
var typographyStyle = css(["color:", ";", " ", ""], function (_ref) {
  var $appearance = _ref.$appearance;
  return getAppearance($appearance || 'default');
}, function (props) {
  return fontWeight(props.$weight || 'normal');
}, function (_ref2) {
  var $size = _ref2.$size;
  return fontSize($size || 'small');
});

export { typographyStyle };
